import deploymentService from '@/services/amio/deployment.service'
import AmioHttpService from '@/services/amio/amio-http.service'
import { CHANNEL_TYPE_ICON_MAP } from '@/utils/channel.constants'

class ChannelService extends AmioHttpService {
  async channelList(botId) {
    try {
      const deployments = await deploymentService.list(botId)
      return deployments.map(toChannel)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  // one request for all bots: returns { channelsByBotId: { [botId]: [channel, ...] }, failedBotIds: [botId], channels: [channel, ...] }
  // failedBotIds = bots where at least one channel could not be loaded (partial channels may still be present)
  // channels = every channel in the org, bound to a bot or not (used to deploy a bot to an existing channel)
  async channelListByBot() {
    try {
      const { deployments, failedBotIds, channels } = await deploymentService.listForOrg()
      const channelsByBotId = Object.keys(deployments).reduce((byBot, botId) => {
        byBot[botId] = deployments[botId].map(toChannel)
        return byBot
      }, {})
      return { channelsByBotId, failedBotIds: failedBotIds || [], channels: (channels || []).map(withIcon) }
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async channelListForBots(botIds = []) {
    const channelLists = await Promise.all(botIds.map(botId => this.channelList(botId)))
    const seenChannelIds = new Set()

    return channelLists
      .flat()
      .filter(channel => {
        if (seenChannelIds.has(channel.id)) return false

        seenChannelIds.add(channel.id)
        return true
      })
  }
}

function toChannel({ channel }) {
  return withIcon(channel)
}

function withIcon(channel) {
  return {
    ...channel, icon: CHANNEL_TYPE_ICON_MAP[channel.type]
  }
}

export default new ChannelService()
